import React from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";
import img01 from "../../../images/location_new/goodfirms.webp";
import img02 from "../../../images/location_new/clutch.webp";
import img03 from "../../../images/location_new/logo-2.webp";
import img04 from "../../../images/location_new/logo-4.webp";
import img05 from "../../../images/location_new/expertise.webp";
import img06 from "../../../images/location_new/logo-6.webp";
import { Link } from "gatsby";

const Awards = [
  {
    logo: img01,
    title: "GoodFirms",
    description:
      "We are recognized as a top mobile app development company in Houston by Goodfirms",
  },
  {
    logo: img02,
    title: "Clutch",
    description:
      "We are acknowledged as a top iPhone development company in Houston by Clutch.",
  },
  {
    logo: img05,
    title: "Expertise",
    description:
      "We are highlighted as the best mobile app developers in Houston by Expertise.com.",
  },
  {
    logo: img03,
    title: "dotCOMM Awards",
    description:
      "Our company has earned the platinum award by dotCOMM Awards for our excellence in web creation and design.",
  },
  {
    logo: img04,
    title: "TopDevelopers",
    description:
      "We are honored by TopDevelopers as a leading mobile app development company building revolutionary solutions.",
  },
  {
    logo: img06,
    title: "SoftwareWorld",
    description:
      "We are top-rated by SoftwareWorld as a leading software development firm for our next-gen products.",
  },
];
function AwardsUk(props) {
  return (
    <>
      <div className="awards_listing">
        {Awards.map((item, index) => (
          <div className="awards_boxing" key={index}>
            <div className="awards_logo">
              <LazyLoadImage
                src={item.logo}
                effect="blur"
                alt={item.title}
                className="img-fluid"
              />
            </div>
            <div className="awards_txt">
              <h4>{item.title}</h4>
              <p>{item.description}</p>
            </div>
          </div>
        ))}
      </div>
      <div className="btn_more">
        <Link
          to="https://clutch.co/profile/tekrevol"
          rel="noopener"
          className="border_btn"
          aria-label="TekRevol Contact"
        >
          Check Reviews
        </Link>
      </div>
    </>
  );
}

export default AwardsUk;
